export const style = {
    position: "absolute",
    top: "0%",
    right: "0%",
    // transform: "translate(-50%, -50%)",
    minWidth: 400,
    boxShadow: 24,
};
